/* eslint @backstage/no-undeclared-imports: 0 */
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { NoticeBanner, NoticeBannerFieldSchema } from './NoticeBannerExtension';

export const noticeBannerField = {
  name: 'NoticeBanner',
  component: NoticeBanner,
  schema: NoticeBannerFieldSchema,
};

export const NoticeBannerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    ...noticeBannerField,
    schema: NoticeBannerFieldSchema.schema,
  }),
);
